// extracted by mini-css-extract-plugin
export default {"-large":"n6kpXBaokN2P5Y8nYjb3","popover":"CxGtruRELabayVodKmcX"};